<template>
  <footer class="golomt-footer">
    <div class="container pd-t-50 pd-b-30">
      <div class="row">
        <div class="col-md-12 text-center">
          <a
            v-if="
              $store.state.app.activeGroup.logoFooter != undefined &&
                $store.state.app.activeGroup.logoFooter != ''
            "
          >
            <img
              :src="$store.state.app.activeGroup.logoFooter"
              alt="footer_logo"
              class="img-fluid"
            />
          </a>
          <div class="d-flex justify-content-center mg-t-30">
            <div class="nav-item">
              <router-link
                :to="{
                  name: $store.state.app.activeGroup.publicPage.route,
                  params: { id: $store.state.app.homePageId, cid: 0 }
                }"
                class="nav-link text-white"
              >
                Нүүр
              </router-link>
            </div>
            <div class="nav-item">
              <a class="nav-link text-white">Хамтарч ажиллах</a>
            </div>
            <div class="nav-item"><a class="nav-link text-white">FAQ</a></div>
          </div>
          <template v-if="$store.state.app.activeGroup.id == 9247">
            <div class="d-flex justify-content-center mg-t-30">
              <div class="nav-item mg-r-20">
                <a
                  target="_blank"
                  href="https://www.facebook.com/%D0%9C%D0%BE%D0%BD%D0%B3%D0%BE%D0%BB%D1%8B%D0%BD-%D2%AE%D0%BD%D0%B4%D1%8D%D1%81%D0%BD%D0%B8%D0%B9-%D0%9C%D0%B0%D0%BB-%D0%AD%D0%BC%D0%BD%D1%8D%D0%BB%D0%B3%D0%B8%D0%B9%D0%BD-%D0%A5%D0%BE%D0%BB%D0%B1%D0%BE%D0%BE-799240646933474"
                  ><feather type="facebook" class="text-white"></feather
                ></a>
              </div>
              <!-- <div class="nav-item mg-r-20"><feather type="linkedin" class="text-white"></feather></div> -->
              <div class="nav-item">
                <a target="_blank" href="https://www.instagram.com/batsukh833/"
                  ><feather type="instagram" class="text-white"></feather
                ></a>
              </div>
              <!-- <div class="nav-item"><a target="_blank" href="https://www.instagram.com/batsukh833/"><feather type="twitter" class="text-white"></feather></a></div> -->
            </div>
          </template>
          <div v-else class="d-flex justify-content-center mg-t-30">
            <div class="nav-item mg-r-20">
              <feather type="facebook" class="text-white"></feather>
            </div>
            <div class="nav-item mg-r-20">
              <feather type="linkedin" class="text-white"></feather>
            </div>
            <div class="nav-item">
              <feather type="instagram" class="text-white"></feather>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="copyright">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <span>
              © <span>{{ $store.state.app.activeGroup.name | stripHtml }}</span
              >, бүх эрх хуулиар хамгаалагдсан.
            </span>
            <a href="https://www.gosmart.mn" class="text-white" target="_blank">
              <img :src="`${myResBaseUrl}/media/favicon/fav.png`" />
              Хөгжүүлсэн ГөүCмарт ТМ ХХК</a
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data(){
    return{
      myResBaseUrl: "https://res.gosmart.mn/",
    }
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
};
</script>

<style></style>
